import _ from 'lodash'

const CHAIN_LINK_SEPARATOR = '/'
export const CHAIN_LINK_ROOT = ''

export const padCheckpointChain = (chain: string) => {
  return `${CHAIN_LINK_SEPARATOR}${_.trim(chain, CHAIN_LINK_SEPARATOR)}${CHAIN_LINK_SEPARATOR}`
}

export const makePath = (...linksOrPaths: string[]) => {
  const trimmedLinks = linksOrPaths.map(link => _.trim(link, CHAIN_LINK_SEPARATOR))

  return padCheckpointChain(trimmedLinks.join(CHAIN_LINK_SEPARATOR))
}
